import type { DataTableColumn } from '@/components/custom/erp';
import type { Phi } from '@/types/schemas';

export const feeColumns: DataTableColumn<Phi>[] = [
  { field: 'ma_phi', headerName: 'Mã phí', width: 120 },
  { field: 'ten_phi', headerName: 'Tên phí', width: 200 },
  {
    field: 'nhom_phi_1',
    headerName: 'Nhóm phí 1',
    width: 140,
    renderCell: params => {
      return <span>{params.row.nhom_phi_1_data?.ma_nhom || ''}</span>;
    }
  },
  {
    field: 'nhom_phi_2',
    headerName: 'Nhóm phí 2',
    width: 140,
    renderCell: params => {
      return <span>{params.row.nhom_phi_2_data?.ma_nhom || ''}</span>;
    }
  },
  {
    field: 'nhom_phi_3',
    headerName: 'Nhóm phí 3',
    width: 140,
    renderCell: params => {
      return <span>{params.row.nhom_phi_3_data?.ma_nhom || ''}</span>;
    }
  },
  {
    field: 'bo_phan',
    headerName: 'Mã bộ phận',
    width: 140,
    renderCell: params => {
      return <span>{params.row.bo_phan_data?.ma_bp || ''}</span>;
    }
  },
  {
    field: 'trang_thai',
    headerName: 'Trạng thái',
    width: 150,
    renderCell: params => {
      switch (params.row.trang_thai) {
        case 1:
          return '1. Còn sử dụng';
        case 0:
          return '0. Không sử dụng';
        default:
          return '';
      }
    }
  }
];
